import { fontWeight, fontSizeValues, spacing, text, status } from "@atlas-int/tokens";
import { psColors } from "./constants";

const NodeColorLegend = () => {
  return (
    <div>
      <div
        style={{
          fontWeight: fontWeight.bold,
          fontSize: fontSizeValues.xs,
          marginBottom: spacing[4],
          color: status.gold,
        }}
      >
        Node Color
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: spacing[2],
        }}
      >
        <svg width={12} height={12} style={{ marginRight: spacing[4] }}>
          <path d="M 6,6 L 6,1 A 5,5 0 0,1 11,6 Z" fill="yellow" />
          <path d="M 6,6 L 11,6 A 5,5 0 0,1 6,11 Z" fill="green" />
          <path d="M 6,6 L 6,11 A 5,5 0 0,1 1,6 Z" fill="blue" />
          <path d="M 6,6 L 1,6 A 5,5 0 0,1 6,1 Z" fill="red" />
          <circle
            r={5}
            cx={6}
            cy={6}
            stroke={text.primary}
            strokeWidth="0.5"
            fill="none"
          />
        </svg>
        <div style={{ fontSize: fontSizeValues.xs, color: text.primary }}>
          Colored Nodes: High export
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <svg width={12} height={12} style={{ marginRight: spacing[4], overflow: "visible" }}>
          <circle
            fill={psColors.nodeInactive}
            r={5}
            stroke={text.primary}
            cx={6}
            cy={6}
            strokeWidth="0.5"
          />
        </svg>
        <div style={{ fontSize: fontSizeValues.xs, color: text.primary }}>
          Grey Nodes: Low or no export
        </div>
      </div>
    </div>
  );
};

export default NodeColorLegend;
